import React, {useEffect, useLayoutEffect} from 'react'
import {MdClose, MdSearch} from 'react-icons/md'
import getQueryObject from '@helpers/misc/getQueryObject'
import {EVENTS, sendPosthogData} from '@helpers/posthog'
import useDebounce from '@hooks/useDebounce'
import useKeyboardEvent from '@hooks/useKeyboardEvent'
import useRef from '@hooks/useRef'
import useState from '@hooks/useState'
import Container from '@packages/justo-parts/lib/components/Container'
import {useRouter} from 'next/router'
import {useTranslation} from 'next-i18next'

import styles from './styles.module.css'

export default function Bar(props) {
  const {filter, setFilter} = props
  const [localSearch, setLocalSearch] = useState(filter)
  const [searching, setSearching] = useState(false)
  const input = useRef(null)
  const {t} = useTranslation('website')
  const router = useRouter()
  const [debouncedFilter, isDebouncing] = useDebounce(localSearch, 400)

  useKeyboardEvent('Escape', () => {
    setSearching(false)
  })

  useEffect(() => {
    const q = getQueryObject(router)?.search
    const qValue = Array.isArray(q) ? q[0] : q

    if (qValue !== '' && filter !== qValue) {
      setFilter(qValue)
      setLocalSearch(qValue)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // We want to do this only on load

  useEffect(() => {
    if (debouncedFilter !== filter) {
      setFilter(debouncedFilter)
      if (debouncedFilter && debouncedFilter !== getQueryObject(router)?.search) {
        const url = new URL(window.location.href)
        url.searchParams.set('search', debouncedFilter)
        window.history.pushState(null, '', url.toString())
      }
    }
  }, [debouncedFilter, setFilter, filter, router])

  useLayoutEffect(() => {
    if (searching) {
      input.current.focus()
    } else {
      setFilter('')
      setLocalSearch('')
    }
  }, [searching])

  const containerClassName = {
    v1: styles.container,
    v2: styles.withBarContainer,
    mobile: styles.withBarContainerMobile
  }[props.layout]

  const content = (
    <>
      <div
        className={styles.search}
        onClick={() => {
          sendPosthogData(EVENTS.clicked.search)
          setSearching(!searching)
        }}>
        <MdSearch size={20} />
      </div>
      {searching ? (
        <>
          <input
            ref={input}
            className={styles.input}
            value={localSearch}
            onChange={event => setLocalSearch(event.target.value)}
            type="text"
            placeholder={t('order.labelSearchProduct')}
          />
          <div className={styles.close} onClick={() => setSearching(!searching)}>
            <MdClose size={20} />
          </div>
        </>
      ) : (
        props.children
      )}
    </>
  )

  if (props.layout === 'v1') {
    return (
      <div className={containerClassName}>
        <div className={styles.inner}>{content}</div>
      </div>
    )
  }

  return (
    <div className={containerClassName}>
      <Container className={styles.inner}>{content}</Container>
    </div>
  )
}
